import Vue from "vue";

Vue.prototype.$puntale = [
  {
    key: "puntale0"
  },
  {
    key: "puntale1"
  },
  {
    key: "puntale2"
  },
  {
    key: "puntale3"
  },
  {
    key: "puntale4"
  },
  {
    key: "puntale5"
  },
  {
    key: "puntale6"
  }
];
